<template>
  <div class="mastery-modal-white">
    <img
      v-if="headerImage"
      class="header-image"
      :class="[headerImageSize]"
      :src="headerImageSrc"
    >
    <div class="title">
      {{ title }}
    </div>
    <div class="content">
      <slot />
    </div>
    <mastery-button
      v-if="primaryActionText"
      :variant="buttonVariant"
      @mastery-button-clicked="$emit('primary-action-clicked')"
    >
      {{ primaryActionText }}
    </mastery-button>
    <button
      v-if="secondaryActionText"
      class="secondary-action"
      @click="$emit('secondary-action-clicked')"
    >
      {{ secondaryActionText }}
    </button>
  </div>
</template>

<script>
import MasteryButton from '@components/ui/masteryButton';

export default {
  components: { MasteryButton },
  props: {
    buttonVariant: {
      type: String,
    },
    headerImage: {
      type: [Object, String],
    },
    headerImageSize: {
      type: String,
    },
    primaryActionText: {
      type: String,
    },
    secondaryActionText: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  computed: {
    headerImageSrc() {
      if (typeof this.headerImage === 'string') {
        // is a static file name
        return require(`../../assets/images/${this.headerImage}`);
      } else {
        // is an attachment object
        return this.headerImage.url;
      }
    },
  },
};
</script>

<style lang="scss">
.mastery-modal-white {
  .title {
    @include charter-font;
    font-size: rem-calc(32);
  }

  .content {
    line-height: 1.5;
    margin: rem-calc(16) 0 rem-calc(48);
  }

  .secondary-action {
    background: transparent;
    display: block;
    font-size: rem-calc(14);
    margin: rem-calc(24) auto rem-calc(8);

    &:hover {
      text-decoration: underline;
    }
  }

  .header-image {
    display: block;
    margin: rem-calc(16) auto rem-calc(32) auto;
    width: 60%;

    &.small {
      width: rem-calc(96);
    }
  }
}
</style>
